var $dbc649b992588dbe$exports = {};
$dbc649b992588dbe$exports = {
    "maximum": `\u{41C}\u{430}\u{43A}\u{441}\u{438}\u{43C}\u{443}\u{43C}`,
    "minimum": `\u{41C}\u{438}\u{43D}\u{438}\u{43C}\u{443}\u{43C}`
};


export {$dbc649b992588dbe$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
